<script>

  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';

  export let amount, futureAmount, currency, settings, inCheckout;

  export const onAmountChange = () => {
  };

  export const getPaymentDetails = async (billingInfo) => {
    return new Promise(async (resolve, reject) => {
      let amountToCharge = amount > -0.01 && amount < 0.01 ? (currency === 'NGN' ? 5000 : 20)/*50 NGN or 0.2 USD*/ : Math.round(amount * 100);
      let handler = window.PaystackPop.setup({
        key: settings.publicKey,
        email: External.userEmail,
        channels: ['card'],
        amount: amountToCharge,
        currency: currency,
        metadata: {
          custom_fields: [
            {
              display_name: 'Website',
              variable_name: 'website',
              value: External.userDomain
            }
          ]
        },
        callback: function(response) {
          resolve({
            nonce: response.reference
          });
        },
        onClose: function() {
          reject();
        }
      });
      handler.openIframe();
    });
  };

  let setup = async () => {
  };

  let teardown = () => {
  };

  onMount(() => {
    External.WebPlatform.requestScripts([{
      script: 'https://js.paystack.co/v1/inline.js',
      check: () => !External.isUndefined(window.PaystackPop)
    }], setup);
  });

  onDestroy(teardown);
</script>

<div class="payment-info">
  <div class="col20 f-left card-form">
    <div class="col20 f-left">
      <span class="mt-15 mb-15" style="color: #666; line-height:1.4; font-size: 14px">
        {inCheckout ? M.PAYSTACK_SUBSCRIBE : M.PAYSTACK_CHANGE_CARD}
      </span>
    </div>
  </div>
</div>
